// material-ui
import { Button, Link, CardMedia, Stack, Typography, Dialog } from "@mui/material";
import { useState } from "react";
// project-imports
import MainCard from "components/MainCard";

// assets
import avatar from "assets/images/users/customer-support-1.png";
import AnimateButton from "components/@extended/AnimateButton";
import { PopupTransition } from "components/@extended/Transitions";
// ==============================|| DRAWER CONTENT - NAV CARD ||============================== //
import Info from "../../../../pages/App_Aplicacion/Soporte/index";
// const NavCard = () => (
const NavCard = () => {
  const [showpopup, setshowpopup] = useState<boolean>(false);
  const ClodePopup = (row: any) => {
    setshowpopup(!showpopup);
  };
  const handleClick = () => {
    const aduana = sessionStorage.getItem('aduana');
    if (aduana) {
      sessionStorage.setItem("aduanainfo", aduana);
    }
    setshowpopup(!showpopup);
  };
  return (
    <>
      <Dialog
        id="modalAddForm"
        // fullScreen
        maxWidth="md"
        TransitionComponent={PopupTransition}
        keepMounted={true}
        fullWidth
        onClose={ClodePopup}
        open={showpopup}
        sx={{ "& .MuiDialog-paper": { p: 0 }, transition: "transform 1025ms" }}
        aria-describedby="alert-dialog-slide-description"
      >
        <Info />
      </Dialog>
      <MainCard sx={{ bgcolor: "secondary.lighter", m: 3 }}>
        <Stack alignItems="center" spacing={2.5}>
          <CardMedia component="img" image={avatar} />
          <Stack alignItems="center">
            <Typography variant="h5">¿Necesitas ayuda?</Typography>
            <Typography variant="h6" color="secondary">
              {/* 1 Day Response Time */}
            </Typography>
          </Stack>
          <AnimateButton>
            <Button
              variant="shadow"
              size="small"
              component={Link}
              // href="https://phoenixcoded.authordesk.app/"
              // target="_blank"
              onClick={handleClick}
            >
              Contáctanos
            </Button>
          </AnimateButton>
        </Stack>
      </MainCard>
    </>
  );
};
export default NavCard;
